'use client'

import classNames from 'classnames'
import styles from './AddToPreferences.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
    addFavoriteItem,
    removeFavoriteItem,
} from '@/shared/store/slice/favoriteSlice'
import { TOAST_ERROR, TOAST_SUCCESS } from '@/shared/constants/toastTypes'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'

export function AddToPreferences({ item, productId, className }) {
    const dispatch = useDispatch()
    const { items: itemsFavorite } = useSelector((state) => state.favorite)
    const { userAuth: isAuth } = useGetIsAuthUser()
    const itemInFavorite = !!itemsFavorite.find(
        (itemFavorite) => itemFavorite.product_id === productId
    )
    const addFavorite = () => {
        if (itemInFavorite) {
            return dispatch(removeFavoriteItem(item))
        }
        TOAST_SUCCESS('Товар добавлен в избранное')
        dispatch(addFavoriteItem(item))
    }

    return (
        <div className={`preferences-item ${className}`} onClick={addFavorite} title='Добавить в избранное'>
            <svg
                className={classNames(
                    styles.icon,
                    itemInFavorite ? styles.active : ''
                )}
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                fill="none"
                viewBox="6 4.5 14 16"
                strokeWidth="1.2"
            >
                <path
                    className={styles.path}
                    stroke="#040404"
                    width="26"
                    height="26"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12.857 18.773s-7.164-3.916-7.164-8.615c0-4.7 5.572-5.09 7.164-1.414 1.592-3.677 7.164-3.285 7.164 1.414 0 4.7-7.164 8.615-7.164 8.615z"
                ></path>
            </svg>
        </div>
    )
}
